import { UserRole } from '../../oglasnik-v3/shared/models/user-profile.model';

/**
 * Default home ruta po roli. Candidate → profil; svi ostali
 * (employer/admin/subadmin) zasad dijele /dashboard (V3 nema /admin —
 * kad dođe, dodaj poseban case za admin/subadmin).
 */
export function roleHomePath(role: UserRole): string[] {
  return role === 'candidate' ? ['/profile'] : ['/dashboard'];
}
